
import { db, analytics } from './firebase.js';
import { collection, getDocs, query, orderBy } from "firebase/firestore";

async function initHome() {
    await Promise.all([
        renderServices(),
        renderReferences()
    ]);

    // Refresh Lucide icons after dynamic rendering
    if (typeof lucide !== 'undefined') {
        lucide.createIcons();
    }
}

async function renderServices() {
    const servicesGrid = document.querySelector('#work .cards-grid');
    if (!servicesGrid) return;

    try {
        const q = query(collection(db, "services"), orderBy("order", "asc"));
        const querySnapshot = await getDocs(q);

        servicesGrid.innerHTML = '';
        querySnapshot.forEach((doc) => {
            const service = doc.data();
            const serviceCard = document.createElement('div');
            serviceCard.className = 'card';

            let itemsHtml = service.items.map(item => `<p>${item}</p>`).join('');

            serviceCard.innerHTML = `
                <div class="card-header">
                    <i data-lucide="${service.icon}" class="service-icon"></i>
                    <h3>${service.title}</h3>
                </div>
                ${itemsHtml}
            `;
            servicesGrid.appendChild(serviceCard);
        });
    } catch (error) {
        console.error("Error fetching services:", error);
    }
}

async function renderReferences() {
    const logoGrid = document.querySelector('#references .logo-grid');
    if (!logoGrid) return;

    try {
        const q = query(collection(db, "references"), orderBy("order", "asc"));
        const querySnapshot = await getDocs(q);

        logoGrid.innerHTML = '';
        querySnapshot.forEach((doc) => {
            const ref = doc.data();
            const logoItem = document.createElement('div');
            logoItem.className = 'logo-item';
            logoItem.innerHTML = `<img src="${ref.logo}" alt="${ref.name}">`;
            logoGrid.appendChild(logoItem);
        });
    } catch (error) {
        console.error("Error fetching references:", error);
    }
}

// Run on load
initHome();
